export const LAUNCH_CALENDAR_NOTIFICATION_SUBSCRIBED_COPY =
  'You have been added to the list! We’ll let you know when this product becomes available!';

export const LAUNCH_CALENDAR_SHOES_PLACEHOLDER_IMAGE =
  'https://m.media-amazon.com/images/G/01/zappos/launch-calendar/shoe-skeleton/shoe_placeholder.jpg';

export const LC_SHOES_PLACEHOLDER_IMAGE_ID = '31-olwdiXxL';

export const LC_SWATCH_IMAGE_ZOOM_IN_SUFFIX = '._CACC,300,300_';

// API status
export const SUCCESS = 'SUCCESS';
export const FAILED = 'FAILED';
export const FETCHING = 'FETCHING';

export const LC_SHOES_PLACEHOLDER_IMAGES = [
  {
    imageId: LC_SHOES_PLACEHOLDER_IMAGE_ID,
    type: 'MAIN'
  }
];
